import { Action, Dispatch, combineReducers, Reducer, UnknownAction } from 'redux';
import { CaseState, caseReducer } from './case';
import { DetailsState, detailsReducer, detailsSaga } from './details';
import { LoginState, loginReducer, LoginActionTypes } from './login';
import { all, fork } from 'redux-saga/effects';

import { NetworkState } from './network/types';
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { SharedState, NavigationState } from './shared/types';
import caseSaga from './case/sagas';
import loginSaga from './login/sagas';
import { authSessionSaga } from './auth/authSessionSaga';
import { networkReducer } from './network/reducer';
import { sharedReducer } from './shared/reducer';
import sharedSaga from './shared/sagas';
import * as loginActions from './login/actions';
import { ActionType } from 'typesafe-actions';
import navigationReducer from './navigation/reducer';

// The top-level state object
export interface ApplicationState {
  readonly login: LoginState;
  readonly caseState: CaseState;
  readonly network: NetworkState;
  readonly details: DetailsState;
  readonly shared: SharedState;
  readonly navigation: NavigationState;
}

// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = UnknownAction> {
  readonly dispatch: Dispatch<A>;
  readonly navigate: ReturnType<typeof useNavigate>;
  readonly params: ReturnType<typeof useParams>;
  readonly location: ReturnType<typeof useLocation>;
}

// Whenever an action is dispatched, Redux will update each top-level application state property
// using the reducer with the matching name. It's important that the names match exactly, and that
// the reducer acts on the corresponding ApplicationState property type.
// export const rootReducer = combineReducers<ApplicationState>({
//   login: loginReducer,
//   navigation: navigationReducer,
//   network: networkReducer,
//   caseState: caseReducer
// });
// export const appReducer = combineReducers<ApplicationState>({
export const appReducer = combineReducers({
  login: loginReducer,
  caseState: caseReducer,
  network: networkReducer,
  details: detailsReducer,
  shared: sharedReducer,
  navigation: navigationReducer
});

export type LoginAction = ActionType<typeof loginActions>;

export const rootReducer: Reducer<ApplicationState, LoginAction> = (state, action: LoginAction) => {
  if (action.type === LoginActionTypes.LOGOUT) { // CHANGE TO RESET_STATE ACTION WHICH WILL BE HANDLED ONLY HERE!?
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

// Here we use `redux-saga` to trigger actions asynchronously. `redux-saga` uses something called a
// "generator function", which you can read about here:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/function*
export function* rootSaga() {
  yield all([
    fork(loginSaga),
    fork(caseSaga),
    fork(detailsSaga),
    fork(sharedSaga),
    fork(authSessionSaga),
  ]);
}
